// eslint-disable-next-line no-restricted-imports
import { Global } from '@emotion/react';
import { isFeatureEnabled } from '@iheartjane/config';

import { Conversation } from './components/conversation';
import { ConversationProvider } from './providers/conversationProvider';

const globalStyles = { body: { margin: 0 } };

export const App = () => {
  if (!isFeatureEnabled('twoWayMessaging')) {
    return null;
  }

  // eslint-disable-next-line @iheartjane/workspace/no-dom-globals-in-react-fc
  const conversationId = new URLSearchParams(window.location.search).get(
    'conversation-id'
  );
  if (!conversationId) {
    return <h1>Not found</h1>;
  }

  return (
    <>
      <Global styles={globalStyles} />
      <ConversationProvider conversationId={conversationId}>
        <Conversation />
      </ConversationProvider>
    </>
  );
};
